import { render, staticRenderFns } from "./calculations-index.vue?vue&type=template&id=2b20ab6e"
import script from "./calculations-index.vue?vue&type=script&lang=js"
export * from "./calculations-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports